import { mapState, mapGetters, mapActions } from "vuex";

export default {
    computed: {
        ...mapState('User', ['currentTenant', 'listTenant', 'profile']),
        ...mapState('Group', ["currentGroup",]),
        ...mapGetters('User', ["isAuthenticated", "hasRole", "hasRoleUid"]),
        hasRoleManager(){ return this.hasRoleUid(this.currentGroup.role_manager); },
        tr_menu_title(){
            return {
                tr: "tkpi.menu_" + this.currentGroup.stackholder_kind.toLowerCase(),
                null: this.currentGroup.tkpi_tracking,
            }
        },
        tr_menu_stackholder(){
            return {
                tr: "tkpi.menu_" + this.currentGroup.stackholder_kind.toLowerCase(),
                null: this.currentGroup.get_stackholder_kind_display,
            }
        },
        tr_menu_stocktype(){
            return {
                tr: "tkpi.stocktype_" + this.currentGroup.stock_kind.toLowerCase(),
                null: this.currentGroup.get_stock_kind_display,
            }
        },
        // A SUPPRIMER
        ...mapState('Company', ["currentCompany",]),
    },
    methods: {
        ...mapActions('User', ['getTenants', 'choiceTenant']),
        tenantFilename(suffix){ return this.currentGroup.named_id+suffix; },
        tenantFilenameDated(suffix){ return this.currentGroup.named_id+suffix; },
        tenantParams(){ return { group: this.currentTenant.group.uid } },
        urlTab(name) { return { name: name, uid: this.currentTenant.uid }; },
        async prepareAuth(){
            await this.$store.dispatch("User/setProfile");
            await this.$store.dispatch("User/setListTenant");
            await this.$store.dispatch("User/choiceTenantNamed", this.$route.params.groupUid);
            if(this.has(this.currentTenant))
                await this.$store.dispatch("Group/setCurrentGroup", this.$group_named_id);

        },
    },
}
